import React, { useState } from 'react'
import Loader from '../../../../../../presentationals/Loader/Loader.component'
import PiePage from '../../../utils/PiePage.component'
import InputField from '../../../utils/InputMUI'
import { SaveUpdateOEMEvScorecard } from '../../ActionCreator';

// export default function BasicDetails({ handlePage, handleTabs,communityId }) {
export default function BasicDetails({  handleTab,pageData }) {
    const [responseMsg, setresponseMsg] = useState("")
    const [errors, setErrors] = useState({})
    const [loaderState, setloaderState] = useState(false)
    const [ObjectData, setObjectData] = useState({
        oemName:"",
        minNPA: '',
        maxNPA: '',
        weightage: '',
    })


    const inputChange = (e, type) => {

        let changeObjectData = Object.assign({}, ObjectData)

    
            changeObjectData[type] = e
        

        setObjectData(changeObjectData)

    }


    const saveHandler = (e) => {
        if (e === 'save') {
            setloaderState(true)
            const obj = {...ObjectData,pageData:pageData?.makeClass}
            SaveUpdateOEMEvScorecard(obj,(callback)=>{
                setloaderState(false)
                console.log(callback)
                if(callback == "success"){

                    handleTab("list", "")
                }
            })
        } else if (e === 'close') {
            handleTab("list", "")
        }
    }

    return (
        <>
         <div className="communitySection">
            <div className='container hoverNone card'>
                {loaderState ?
                    <Loader />
                    : null}

                <PiePage
                    totalPage={2}
                    currentPage={2}
                    heading={'Add BRE Configuration'}
                />


                <div className='row'>
                    <div className='col-sm-4 col-xs-12 ' style={{ marginBottom: '12px' }}>
                        <InputField
                            label="Min NPA"
                            variant="outlined"
                            value={ObjectData.minNPA}
                            name="minNPA"
                            id="minNPA"
                            type="number"
                            onChange={e => inputChange(e, 'minNPA')}
                            size="small"
                        // required={true}
                        />
                        {/* {
                            errors?.address &&
                            <div id="nameHelp" className="form-text text-danger">{errors?.address}</div>
                        } */}

                    </div>
                    <div className='col-sm-4 col-xs-12  ' style={{ marginBottom: '12px' }} >
                        <InputField
                            label="Max NPA"
                            variant="outlined"
                            value={ObjectData.maxNPA}
                            name="maxNPA"
                            id="maxNPA"
                            type="number"
                            onChange={e => inputChange(e, 'maxNPA')}
                            size="small"

                        />
                        {/* {
                            errors?.area &&
                            <div id="nameHelp" className="form-text text-danger">{errors?.area}</div>
                        } */}


                    </div>
                    <div className='col-sm-4 col-xs-12 ' style={{ marginBottom: '12px' }}>
                        <InputField

                            label="Weightage"
                            variant="outlined"
                            value={ObjectData.weightage}
                            name="weightage"
                            id="weightage"
                            type="text"
                            onChange={e => inputChange(e, 'weightage')}
                            size="small"

                        />
                        {/* {
                            errors?.email &&
                            <div id="nameHelp" className="form-text text-danger">{errors?.email}</div>
                        } */}

                    </div>
                </div>

              
            
                <div className='mb-3 mt-2 row' style={{ margin: '15px 0' }}>
                    <div className="form-text text-danger">{responseMsg}</div>
                    <div className="col-12 text-center">

                        <button className="cred-btn cancel-btn" style={{ fontSize: '16px' }} onClick={e => saveHandler('close')}>Close</button>

                        <button className="cred-btn" style={{ fontSize: '16px' }} onClick={e => saveHandler('save')}>Save and Continue</button>
                    </div>
                </div>
            </div>
            </div>
        </>
    )
}
